import { Action, Store, MiddlewareAPI, Dispatch } from 'redux'

export const PROCESSOR_API_SOURCE = 'processorAPI'
export const PASTE_SOURCE = 'pasteSource'

interface IOperationBase<T> extends Action<T> {
  source?: string
}

export interface IInsertOperation extends IOperationBase<'insert'> {
  start: number
  text: string
  // Deprecated
  slices?: ISlice[]
}

export interface IDeleteOperation extends IOperationBase<'delete'> {
  start: number
  length: number
}

export interface ISelectOperaion extends IOperationBase<'select'> {
  start: number
  length: number
}

export interface ISliceOperation
  extends IOperationBase<'slice-insert' | 'slice-delete' | 'slice-data'> {
  slice: ISlice
  data?: unknown
}

export type TextOperation =
  | IInsertOperation
  | IDeleteOperation
  | ISelectOperaion
  | ISliceOperation
  | IOperationBase<'render'>

export interface ITextProcessorMiddleware {
  (api: MiddlewareAPI<Dispatch<TextOperation>, IProcessorState>): (
    next: Dispatch<TextOperation>,
  ) => (action: TextOperation) => void
}

export interface IRange {
  start: Readonly<number>
  length: Readonly<number>
  end: Readonly<number>
}

export interface ISliceGetString {
  (content: string, slice: ISlice, format?: string): string
}

export interface ISlice<T = unknown> {
  id?: string
  range: IRange
  type?: Readonly<string>
  data?: T
  getString?: ISliceGetString
}

export type SliceWithoutRange = Omit<ISlice, 'range'>

export interface SliceComparator {
  (a: SliceWithoutRange, b: SliceWithoutRange): boolean
}

export interface ProcessorContent {
  text: Readonly<string>
  slices: ReadonlyArray<ISlice>
}

export interface IProcessorState extends ProcessorContent {
  selection: IRange
}

export type PreloadImagesArray = { url: string; name: string; file: File }[]

export type LoadingMessagesThreadsState = { isLoading: boolean }[]

export interface ITextProcessor {
  store: Store<IProcessorState>

  getSelection: () => IRange
  getSlices: () => ReadonlyArray<ISlice>
  getState: () => IProcessorState
  getText: () => string

  delete: (start: number, length: number) => void
  insert: (start: number, text: string, slices?: ISlice[], source?: string) => void
  select: (start: number, end?: number) => void
  input: (text: string, selectionIndex: number, slices?: Partial<ISlice>[]) => void
  paste: (text: string, slices?: ISlice[]) => void
  deleteSlice: (slice: ISlice) => void
  insertSlice: (slice: ISlice) => void
  setSliceData: (slice: ISlice, data: unknown) => void

  render: () => void
}

export interface IProcessorFabric {
  (state?: IProcessorState): ITextProcessor
}
